module.exports = __webpack_public_path__ + "img/niuping.67d9b566.png";